// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import Table from "../../../../components/Table";

// MARK: Stores
import GalleryStore from "../../../../stores/GalleryStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	galleryStore: GalleryStore;
}

@inject("galleryStore")
@observer
export default class GallerysTable extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.galleryStore.getGalleries();
	};

	public render() {
		const { galleryStore } = this.props;
		return (
			<>
				<Table
					title={strings.gallery.title}
					rows={galleryStore.galleriesTableRows}
					header={galleryStore.header}
					pageOffset={galleryStore.pageOffSet}
					loading={galleryStore.loading}
					tableIsEmptyMessage={strings.gallery.table.tableIsEmpty}
					prevPage={galleryStore.previousPage}
					nextPage={galleryStore.nextPage}
					onAddClick={() => galleryStore.startGalleryCreateOrEdit()}
					onEditClick={(galleryId) => galleryStore.startGalleryCreateOrEdit(galleryId)}
					onDeleteClick={(galleryId: string, galleryName: string) => galleryStore.openDeleteGalleryDialog(galleryId, galleryName)}
				/>
			</>
		);
	}
}
